import { Container, createStyles, makeStyles } from '@material-ui/core';
import cn from 'classnames';
import * as React from 'react';
import { TranquiTheme } from '../App/theme';

interface PortalBaseProps {}

const PortalBase: React.FC<PortalBaseProps> = ({ children }) => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();

  return (
    <Container className={cn(classes.root)}>
      {children!}
    </Container>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  root: {
    boxSizing: 'border-box',
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4),
      paddingTop: theme.spacing(2),
    },
  },
}));

export default PortalBase;
